import { Injectable, signal } from '@angular/core';
import { LoginUser, RegistrationCredentials } from 'src/app/models/user.model';
import { environment } from 'src/environments/environment';
import { Route, Router } from '@angular/router';
import { AuthGuard } from '../../Guards/auth-guard.guard';

@Injectable({
  providedIn: 'root', // Makes it available app-wide
})
export class StateService {
  constructor(private router: Router) {}
  notificationsCount = signal(0);
  deviceId = signal('');
  private readonly identityVerificationUrl = 'url';
  verificationIdentityUrl = signal<string | null>(null);
  // Memory only, never persisted. Used to re-check the Didit result through login.
  private registrationCredentials = signal<RegistrationCredentials | null>(null);
  private apiUrl = `${environment.apiUrl}/user/portal/login`;

  private readonly userKey = 'userInfo';
  userInfo = signal<LoginUser | null>(
    JSON.parse(localStorage.getItem(this.userKey) ?? 'null') ?? {
      username: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      last_name2: '',
      email: '',
      avatar: '',
      roles: [],
      knostos_id: 0,
      cell_phone: '',
      facilities: '',
      contact_uuid: '',
      company_uuid: '',
      reset_password_status: 'NONE',
      twixor_enabled: false,
      twixor_department_id: '',
      currentRole: '',
      validation_status: '',
      is_active: false,
    }
  );

  isLoading = false;
  error: boolean = false;
  errorDescriptions = {
    incorrect_input:
      "We couldn't find an account with those details. Please double-check the entered username or                                     .",
    missing_username: 'Please enter your username.',
    missing_password: 'Please enter your password.',
    session_end: 'The session has ended, Please login again.',
  };
  displayedError = '';

  // Update the notifications count
  setNotificationsCount(count: number): void {
    this.notificationsCount.set(count);
  }

  // Get the current notifications count
  getNotificationsCount(): number {
    return this.notificationsCount();
  }

  setDeviceId(id: string): void {
    this.deviceId.set(id);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('userInfo');
  }

  getDeviceId(): string {
    return this.deviceId();
  }

  // Save user info and persist it in localStorage
  updateUserInfo(newInfo: LoginUser): void {
    localStorage.setItem(this.userKey, JSON.stringify(newInfo));
    this.userInfo.set(newInfo);
    console.log('Updating user info');
    // this.userInfo()?.twixor_enabled && this.addChatRoute(this.userInfo()!);
  }

  addChatRoute(userInfo: LoginUser) {
    console.log(
      `Adding the chat route for user ${userInfo.username}, ${userInfo.first_name}`
    );
    const chatRoute: Route = {
      path: 'chat',
      loadChildren: () => import('chat-library').then((m) => m.ChatPageModule),
      data: {
        url: environment.chatUrl,
        departmentId: environment.chatDepartmentId,
        customerId: JSON.stringify(userInfo.cell_phone),
        eId: '103',
        countryCode: '1',
        customerDetails: {
          Custumerknostosid: userInfo.knostos_id,
          CustumerProfilePicture: userInfo.avatar,
          Custumername: userInfo.first_name,
          Custumerlastname: userInfo.last_name,
          Custumercellnumber: userInfo.cell_phone,
          Custumeremail: userInfo.email,
          Custumerfacility: userInfo.facilities,
        },
      },
      canActivate: [AuthGuard],
    };

    this.router.resetConfig([...this.router.config, chatRoute]);
  }

  updateUserAvatar(newAvatar: string): void {
    const storedUser = localStorage.getItem(this.userKey);
    if (storedUser) {
      const userInfo = JSON.parse(storedUser);
      console.log(userInfo.avatar);
      userInfo.avatar = newAvatar; // Update avatar only
      this.updateUserInfo(userInfo); // Use existing function to update
    }
  }

  setIdentityVerificationUrl(url: string): void {
    this.verificationIdentityUrl.set(url);
    localStorage.setItem(this.identityVerificationUrl, url);
  }

  getIdentityVerificationUrl() {
    return this.verificationIdentityUrl() ?? null;
  }

  deleteVerificationIdentityUrl() {
    this.verificationIdentityUrl.set(null);
    localStorage.removeItem(this.identityVerificationUrl);
  }

  setRegistrationCredentials(credentials: RegistrationCredentials): void {
    this.registrationCredentials.set(credentials);
  }

  getRegistrationCredentials(): RegistrationCredentials | null {
    return this.registrationCredentials();
  }

  clearRegistrationCredentials(): void {
    this.registrationCredentials.set(null);
  }

  clearUser() {
    this.userInfo.set(null); // clear the observable value
    this.verificationIdentityUrl.set(null);
    this.registrationCredentials.set(null);
    localStorage.removeItem('PLATFORM');
    localStorage.removeItem('URL');
    localStorage.removeItem('cCode');
    localStorage.removeItem('eId');
    localStorage.removeItem('customerId');
    localStorage.removeItem('chatState');
    localStorage.removeItem('AUTH_TOKEN');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('userInfo');
    localStorage.removeItem(this.identityVerificationUrl);
    sessionStorage.clear();
  }

  getUserInfo(): LoginUser | null {
    return this.userInfo();
  }
}
